// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_93444fe79c--wrapper--2_-lc","header":"_93444fe79c--header--3Kdsd","text":"_93444fe79c--text--AuctM","emoji":"_93444fe79c--emoji--2oXg3"};